import React, {useContext, useState} from 'react';
import { Redirect } from 'react-router-dom';

import { Button, Form, Select } from 'antd';
import { CloseCircleOutlined } from "@ant-design/icons";

import {UserContext} from '../../context';
import {setCurrentBranchUuId, getDefaultBranchUuId} from '../../helpers/token';
import AuthPageWrapper from './AuthPageWrapper';
import logo from "../../logo.svg";

const {Option} = Select;
const FormItem = Form.Item;

const SelectBranch = () => {
    const {branches} = useContext(UserContext);
    const [state, setState] = useState('unSelected');
    const confirm = ({branchUuId}) => {
        setCurrentBranchUuId(branchUuId);
        setState('selected');
    };

    if (state === 'selected') return <Redirect to={'/'}/>;

    if (branches.length === 1) {
      setCurrentBranchUuId(branches[0].uuId);
      setState('selected');
    }

    if (branches.length === 0) {
        return (
          <AuthPageWrapper hasNavigation>
              <div className='logo'>
                  <img src={logo} alt='logo'/>
              </div>
              <div className='welcome-text'>ԲԱՐԻ ԳԱԼՈՒՍՏ VELOX</div>
              <div className='empty-state'>
                <div className='empty-notification'>
                  <CloseCircleOutlined style={{ fontSize: '24px', color: '#ff5252' }} />
                  <div className='empty-text'>Դուք կցված չեք որևէ մասնաճյուղի</div>
                </div>
              </div>
          </AuthPageWrapper>
        );
    }

    const isBranchExist = branches.find(branch => branch.uuId === getDefaultBranchUuId());

    return (
        <AuthPageWrapper hasNavigation>
            <div className='logo'>
                <img src={logo} alt='logo'/>
            </div>
            <div className='welcome-text'>ԸՆՏՐԵՔ ՄԱՍՆԱՃՅՈՒՂԸ</div>
            <Form
                className="login-form"
                onFinish={confirm}
            >
                <FormItem name='branchUuId'
                    rules={[{required: true, message: 'Պարտադիր դաշտ'}]}
                    style={{width: 400}}
                    initialValue={isBranchExist ? getDefaultBranchUuId() : ''}
                >
                    <Select size={'large'} placeholder={'Մասնաճյուղ'}>
                        {branches.map((branch) => {
                            return <Option value={branch.uuId} key={branch.uuId}>{branch.name}</Option>
                        })}
                    </Select>
                </FormItem>
                <FormItem style={{width: 400}} wrapperCol={{offset: 6}}>
                    <Button type="primary" htmlType="submit" className="login-form-button">
                        Մուտք
                    </Button>
                </FormItem>
            </Form>

        </AuthPageWrapper>
    )
};


export default SelectBranch;
